import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e33006b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "taghead tagtitle"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Finde ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" in diesem Bild ")
const _hoisted_4 = { class: "taghead tagtasks" }
const _hoisted_5 = {
  key: 0,
  class: "taghead tagmulti"
}
const _hoisted_6 = {
  key: 1,
  class: "package-completed"
}
const _hoisted_7 = { class: "ion-text-left end-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Bravo!", -1))
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "oder", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Anderes Objekt taggen")
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Bestenliste ansehen")
const _hoisted_14 = {
  key: 2,
  class: "package-completed"
}
const _hoisted_15 = { class: "ion-text-left end-text" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Wow!", -1))
const _hoisted_17 = { class: "actions" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Anderes Objekt taggen")
const _hoisted_19 = { class: "actions" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Bestenliste ansehen")
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("anzeigen")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Informationen zum Bild")
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ensemble:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Herstellung", -1))
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "KünstlerIn:", -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Entstehungsort/-gebiet:", -1))
const _hoisted_36 = { key: 3 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Datierung:", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Bildträger", -1))
const _hoisted_39 = { key: 4 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Material:", -1))
const _hoisted_41 = { key: 5 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Technik:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Lokalisierung", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Staat:"),
  /*#__PURE__*/_createTextVNode(" Österreich")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Bundesland:"),
  /*#__PURE__*/_createTextVNode(" Niederösterreich")
], -1))
const _hoisted_46 = { key: 6 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Standort:", -1))
const _hoisted_48 = { key: 7 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Institution:", -1))
const _hoisted_50 = { key: 8 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Allgemeines", -1))
const _hoisted_52 = { key: 9 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Archivnummer:", -1))
const _hoisted_54 = ["href"]
const _hoisted_55 = { key: 10 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Inventarnummer:", -1))
const _hoisted_57 = {
  key: 0,
  class: "folio"
}
const _hoisted_58 = { key: 11 }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fotonummer:", -1))
const _hoisted_60 = { class: "result" }
const _hoisted_61 = { class: "card ion-no-padding" }
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = { class: "card action-2 ion-no-padding" }
const _hoisted_67 = { class: "card svg-container" }
const _hoisted_68 = { class: "card last-card" }
const _hoisted_69 = { class: "result-info" }
const _hoisted_70 = {
  key: 0,
  class: "average-result"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_tagging_page_loader = _resolveComponent("tagging-page-loader")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_image_tagging = _resolveComponent("image-tagging")!
  const _component_side_menu = _resolveComponent("side-menu")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_winning_effect = _resolveComponent("winning-effect")!
  const _component_result_image = _resolveComponent("result-image")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        canGoBack: false,
        title: _ctx.$t('message.tagging')
      }, null, 8, ["title"]),
      (!_ctx.isReady)
        ? (_openBlock(), _createBlock(_component_ion_content, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, { class: "ion-padding" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        "size-xs": "12",
                        "size-sm": "12",
                        "size-md": "12",
                        "size-lg": "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_tagging_page_loader)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_content, {
            key: 1,
            fullscreen: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, { class: "ion-padding" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "no-top-padding",
                        "size-xs": "12",
                        "size-sm": "12",
                        "size-md": "12",
                        "size-lg": "6"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.showPackageCompleted())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _hoisted_2,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.currentWorkObject?.title), 1),
                                _hoisted_3
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taggingWorks, (work, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (_ctx.workIndex === index)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("message.taskNumer", {
                      taskNumber: index + 1,
                      tasksNumber: _ctx.taggingWorks.length,
                    })), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(work.related_work_object_usages, (relatedWorkObjectUsage, subTaskIndex) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: subTaskIndex }, [
                                        (_ctx.currentSubTaskIndex === subTaskIndex)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (work.related_work_object_usages.length > 1)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("message.subTaskNumer", {
                          taskNumber: subTaskIndex + 1,
                          tasksNumber: work.related_work_object_usages.length,
                        })), 1))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", {
                                                class: "tagging",
                                                style: _normalizeStyle({
                        backgroundImage: 'url(' + _ctx.getBgImageUrl(work) + ')',
                      })
                                              }, [
                                                _createVNode(_component_image_tagging, {
                                                  src: _ctx.getWorkImageUrl(work),
                                                  onOnTagging: _ctx.setCoordinates,
                                                  onOnTaggingReset: _cache[0] || (_cache[0] = () => (_ctx.setTagToDefault = false)),
                                                  setTagToDefault: _ctx.setTagToDefault
                                                }, null, 8, ["src", "onOnTagging", "setTagToDefault"])
                                              ], 4),
                                              (_ctx.showSideMenu)
                                                ? (_openBlock(), _createBlock(_component_side_menu, {
                                                    key: 1,
                                                    disableSave: _ctx.disableSave,
                                                    showSaveTag: true,
                                                    showReset: true,
                                                    showHints: 
                        _ctx.taggingWorks[_ctx.workIndex].hints.length === 1
                          ? true
                          : false
                      ,
                                                    showWorkInfo: true,
                                                    showNextWork: true,
                                                    showSkipObject: true,
                                                    finishTagging: true,
                                                    onOnSaveTag: 
                        () =>
                          _ctx.saveTag(
                            index,
                            subTaskIndex,
                            relatedWorkObjectUsage.id
                          )
                      ,
                                                    onOnReset: _cache[1] || (_cache[1] = () => _ctx.reset()),
                                                    onOnShowHint: _cache[2] || (_cache[2] = () => _ctx.setHintModelPresented(true)),
                                                    onOnShowWorkInfo: _cache[3] || (_cache[3] = () => _ctx.setImageInfoModelPresented(true)),
                                                    onOnNextWork: () => _ctx.nextWork(index, subTaskIndex),
                                                    onOnSkipObject: _cache[4] || (_cache[4] = () => _ctx.chooseAnotherObject(false))
                                                  }, null, 8, ["disableSave", "showHints", "onOnSaveTag", "onOnNextWork"]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128)),
                          (_ctx.showPackageCompleted())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                  _hoisted_8,
                                  _createElementVNode("p", null, " Du hast schon " + _toDisplayString(_ctx.results.length) + " Bilder markiert. Weiter so! ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_ion_button, {
                                    expand: "block",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getMoreRandomtaggingWorks()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("message.moreTaggingSameObject", {
                        objectName: _ctx.workObject?.title,
                      })), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_10,
                                  _createVNode(_component_ion_button, {
                                    expand: "block",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.chooseAnotherObject(false)))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                  _createVNode(_component_ion_button, {
                                    expand: "block",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.router.push('/top-list')))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.trophy
                                      }, null, 8, ["icon"]),
                                      _hoisted_13
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.noMoreWorks())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _hoisted_16,
                                  _createElementVNode("p", null, " Du hast alle Bilder mit \"" + _toDisplayString(_ctx.workObject?.title) + "\" in der thingTAG-App markiert. Vielen Dank! ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_ion_button, {
                                    expand: "block",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.chooseAnotherObject(false)))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_18
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_ion_button, {
                                    expand: "block",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.router.push('/top-list')))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.trophy
                                      }, null, 8, ["icon"]),
                                      _hoisted_20
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.isHintModalPresented,
        "swipe-to-close": true,
        "presenting-element": _ctx.$parent?.$refs.ionRouterOutlet,
        onDidDismiss: _ctx.tippsModelDidDismiss,
        cssClass: this.hintClass
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, {
            translucent: true,
            class: "ion-no-border"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { color: "thing-tag" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.tipps")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        shape: "round",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setHintModelPresented(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            "aria-label": _ctx.$t('message.close'),
                            icon: _ctx.close
                          }, null, 8, ["aria-label", "icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        "size-xs": "12",
                        "size-sm": "12",
                        "size-md": "12",
                        "size-lg": "6"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.taggingWorks[_ctx.workIndex].hints.length === 1)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.taggingWorks[_ctx.workIndex].hints, (hint, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "hint-set"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hint, (subhint, index) => {
                                    return (_openBlock(), _createElementBlock("p", { key: index }, [
                                      _createElementVNode("strong", null, _toDisplayString(subhint.type) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(subhint.description), 1)
                                    ]))
                                  }), 128))
                                ]))
                              }), 128))
                            : (_openBlock(), _createElementBlock("p", _hoisted_21, "keine Tipps gefunden")),
                          _hoisted_22,
                          _createVNode(_component_ion_button, {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showInfotext()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Infotext zu " + _toDisplayString(_ctx.workObject?.title), 1),
                              _hoisted_23,
                              _hoisted_24
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "presenting-element", "onDidDismiss", "cssClass"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.isImageInfoModalPresented,
        "swipe-to-close": true,
        "presenting-element": _ctx.$parent?.$refs.ionRouterOutlet,
        onDidDismiss: _ctx.imageInfoModelDidDismiss,
        cssClass: this.imageInfoClass
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, {
            translucent: true,
            class: "ion-no-border"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { color: "thing-tag" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        shape: "round",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setImageInfoModelPresented(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            "aria-label": _ctx.$t('message.close'),
                            icon: _ctx.close
                          }, null, 8, ["aria-label", "icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        "size-xs": "12",
                        "size-sm": "12",
                        "size-md": "12",
                        "size-lg": "6"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.taggingWorks[_ctx.workIndex])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("h3", null, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].bildthema), 1),
                                  (_ctx.taggingWorks[_ctx.workIndex].bildthema_comment)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, " (" + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].bildthema_comment) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.taggingWorks[_ctx.workIndex].ensemble)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                                      _hoisted_28,
                                      _createTextVNode(" " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].ensemble), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_29,
                                (_ctx.taggingWorks[_ctx.workIndex].kuenstler)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                                      _hoisted_31,
                                      (_ctx.taggingWorks[_ctx.workIndex].kuenstler)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].kuenstler), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_33, "Künstler nicht bekannt"))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.taggingWorks[_ctx.workIndex].entstehungsort)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                                      _hoisted_35,
                                      _createTextVNode(" " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].entstehungsort), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.taggingWorks[_ctx.workIndex].datierung)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                      _hoisted_37,
                                      _createTextVNode(" " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].datierung), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_38,
                                (_ctx.taggingWorks[_ctx.workIndex].material)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                                      _hoisted_40,
                                      _createTextVNode(" " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].material), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.taggingWorks[_ctx.workIndex].technik)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                                      _hoisted_42,
                                      _createTextVNode(" " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].technik), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_43,
                                _hoisted_44,
                                _hoisted_45,
                                (_ctx.taggingWorks[_ctx.workIndex].standort)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                                      _hoisted_47,
                                      _createTextVNode(" " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].standort), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.taggingWorks[_ctx.workIndex].institution)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                                      _hoisted_49,
                                      _createTextVNode(" " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].institution), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.taggingWorks[_ctx.workIndex].standort_zusatz)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].standort_zusatz), 1))
                                  : _createCommentVNode("", true),
                                _hoisted_51,
                                (_ctx.taggingWorks[_ctx.workIndex].archiv_nr)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_52, [
                                      _hoisted_53,
                                      _createElementVNode("a", {
                                        href: 
                      'https://realonline.imareal.sbg.ac.at/detail/nr-' +
                      _ctx.taggingWorks[_ctx.workIndex].archiv_nr
                    ,
                                        target: "_blank"
                                      }, _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].archiv_nr), 9, _hoisted_54)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.taggingWorks[_ctx.workIndex].inventar_nr)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_55, [
                                      _hoisted_56,
                                      _createTextVNode(" " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].inventar_nr), 1),
                                      (_ctx.taggingWorks[_ctx.workIndex].fol)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, "(Folio " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].fol) + ")", 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.taggingWorks[_ctx.workIndex].dia_nr)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_58, [
                                      _hoisted_59,
                                      _createTextVNode(" " + _toDisplayString(_ctx.taggingWorks[_ctx.workIndex].dia_nr), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "presenting-element", "onDidDismiss", "cssClass"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.isResultModalPresented,
        "swipe-to-close": false,
        "presenting-element": _ctx.$parent?.$refs.ionRouterOutlet,
        backdropDismiss: false,
        onDidDismiss: _ctx.resultModelDidDismiss
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, {
            translucent: true,
            class: "ion-no-border"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { color: "thing-tag" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.result")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        "size-xs": "12",
                        "size-sm": "12",
                        "size-md": "12",
                        "size-lg": "6"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_ion_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_col, {
                                  size: "7",
                                  "size-xs": "12",
                                  "size-md": "7",
                                  class: "ion-no-margin"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_61, [
                                      (
                          _ctx.getAverageTag(
                            _ctx.workObject?.id,
                            _ctx.taggingWorks[_ctx.workIndex].id,
                            _ctx.currentSubTaskIndex,
                            _ctx.taggingWorks[_ctx.workIndex].related_work_object_usages[
                              _ctx.currentSubTaskIndex
                            ].id
                          ) &&
                          _ctx.getIsRewarded(
                            _ctx.workObject?.id,
                            _ctx.taggingWorks[_ctx.workIndex].id,
                            _ctx.currentSubTaskIndex,
                            _ctx.taggingWorks[_ctx.workIndex].related_work_object_usages[
                              _ctx.currentSubTaskIndex
                            ].id
                          )
                        )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("p", {
                                              innerHTML: 
                          _ctx.$t('message.rewardMessage', {
                            objectName: _ctx.currentWorkObject?.title,
                          })
                        
                                            }, null, 8, _hoisted_62),
                                            _createVNode(_component_winning_effect, {
                                              rewardedPoints: 100,
                                              color: "#e9a200"
                                            })
                                          ], 64))
                                        : (
                          _ctx.getAverageTag(
                            _ctx.workObject?.id,
                            _ctx.taggingWorks[_ctx.workIndex].id,
                            _ctx.currentSubTaskIndex,
                            _ctx.taggingWorks[_ctx.workIndex].related_work_object_usages[
                              _ctx.currentSubTaskIndex
                            ].id
                          ) &&
                          !_ctx.getIsRewarded(
                            _ctx.workObject?.id,
                            _ctx.taggingWorks[_ctx.workIndex].id,
                            _ctx.currentSubTaskIndex,
                            _ctx.taggingWorks[_ctx.workIndex].related_work_object_usages[
                              _ctx.currentSubTaskIndex
                            ].id
                          )
                        )
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              (_ctx.taggingWorks[_ctx.workIndex].hints.length === 1)
                                                ? (_openBlock(), _createElementBlock("p", {
                                                    key: 0,
                                                    innerHTML: 
                            _ctx.$t('message.wrongTagging', {
                              objectName: _ctx.currentWorkObject?.title,
                            })
                          
                                                  }, null, 8, _hoisted_63))
                                                : (_openBlock(), _createElementBlock("p", {
                                                    key: 1,
                                                    innerHTML: 
                            _ctx.$t('message.wrongTaggingManyObjects', {
                              objectName: _ctx.currentWorkObject?.title,
                            })
                          
                                                  }, null, 8, _hoisted_64))
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              _createElementVNode("p", {
                                                innerHTML: _ctx.$t('message.noRewardMessage')
                                              }, null, 8, _hoisted_65),
                                              _createVNode(_component_winning_effect, {
                                                rewardedPoints: 25,
                                                color: "#6999aa"
                                              })
                                            ], 64))
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_col, {
                                  size: "5",
                                  "size-xs": "12",
                                  "size-md": "5",
                                  class: "ion-no-margin"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_66, [
                                      _createVNode(_component_ion_button, {
                                        color: "thing-tag",
                                        expand: "block",
                                        disabled: 
                          _ctx.workIndex !== _ctx.taggingWorks.length
                            ? false
                            : _ctx.currentSubTaskIndex ===
                              _ctx.taggingWorks[_ctx.workIndex].related_work_object_usages
                                .length
                        ,
                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (
                          _ctx.setResultModelPresented(
                            false,
                            _ctx.workIndex,
                            _ctx.currentSubTaskIndex,
                            true
                          )
                        ))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.workIndex + 1 === _ctx.taggingWorks.length
                            ? _ctx.$t("message.next")
                            : _ctx.$t("message.nextIamge")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createVNode(_component_ion_button, {
                                        color: "thing-tag",
                                        expand: "block",
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.chooseAnotherObject(true)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("message.chooseAnotherObjext")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_67, [
                              _createVNode(_component_result_image, {
                                averageTag: 
                      _ctx.getAverageTag(
                        _ctx.workObject?.id,
                        _ctx.taggingWorks[_ctx.workIndex].id,
                        _ctx.currentSubTaskIndex,
                        _ctx.taggingWorks[_ctx.workIndex].related_work_object_usages[
                          _ctx.currentSubTaskIndex
                        ].id
                      )
                    ,
                                tagCoordinates: _ctx.tagCoordinates,
                                tagImage: _ctx.tagImage
                              }, null, 8, ["averageTag", "tagCoordinates", "tagImage"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              (
                      _ctx.getAverageTag(
                        _ctx.workObject?.id,
                        _ctx.taggingWorks[_ctx.workIndex].id,
                        _ctx.currentSubTaskIndex,
                        _ctx.taggingWorks[_ctx.workIndex].related_work_object_usages[
                          _ctx.currentSubTaskIndex
                        ].id
                      )
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.averageResult")) + ":", 1),
                                    _hoisted_71
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "presenting-element", "onDidDismiss"])
    ]),
    _: 1
  }))
}